import React from 'react'

import type { IconColor } from './Icon'
import { Icon, symbolName } from './Icon'

type ArrowRightIconProps = Readonly<{
  size?: number
  color?: IconColor
  className?: string
}>

export function ArrowRightIcon({
  size = 24,
  color = 'ink',
  className,
}: ArrowRightIconProps) {
  return (
    <Icon
      name={symbolName('arrow.right', 'arrow_forward')}
      size={size}
      color={color}
      className={className}
    />
  )
}
